/* eslint-disable no-extend-native */

if (!Promise.prototype.finally) {
  Promise.prototype.finally = {
    finally(fn) {
      const onFinally = value => Promise.resolve(fn()).then(() => value);
      return this.then(
        result => onFinally(result),
        reason => onFinally(Promise.reject(reason))
      );
    }
  }.finally;
}

if (!Promise.allSettled) {
  Promise.allSettled = promises =>
    Promise.all(
      promises.map(promise =>
        promise
          .then(value => ({
            status: "fulfilled",
            value
          }))
          .catch(reason => ({
            status: "rejected",
            reason
          }))
      )
    );
}
